import React, { useState } from 'react'
import styled from 'styled-components'
import { MyCollabo } from './MyCollabo'
import { CollaboInvite } from './CollaboInvite'
import { useTypedSelector } from 'src/redux/root-reducer'

const Wrapper = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.inter};
  font-style: normal;
  font-weight: normal;
  .wrap {
    padding: 0px 0px;
    display: flex;
    align-items: center;
  }
  .explore {
    margin-left: 66px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      margin-left: 30px;
    }
  }

  .investment {
    font-size: ${({ theme }) => theme.fontSize.x2};
    line-height: 26px;
    text-align: center;
    letter-spacing: 0.75px;
    color: ${({ theme }) => theme.colors.Toggleprimary};
    cursor: pointer;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      font-size: ${({ theme }) => theme.fontSize.s};
    }
  }
  .active {
    font-weight: 500;
    color: ${({ theme }) => theme.colors.activeBlue};
  }
  .active-contents {
    display: block;
  }
  .contents {
    display: none;
  }
  .content {
  }
  .active-tabs {
    color: ${({ theme }) => theme.colors.primary};
  }
  .active-tabss {
    visibility: visible;
  }
  .tabss {
    visibility: hidden;
  }
  .pointer {
    display: flex;
    flex-direction: column;
    align-items: center;
    & img {
      margin-top: -10px;
      margin-bottom: 29px;
      width: 6px;
    }
  }
  .point {
    width: 5px;
    height: 5px;
    background-color: ${({ theme }) => theme.colors.primary};
    margin-bottom: 30px;
  }
`
const CollaboToggle = () => {
  const [toggleState, setToggleState] = useState(1)
  const allInvitesLength = useTypedSelector((state) => state.collabo.invites)
  const mycollaboLength = useTypedSelector((state) => state.collabo.all)

  const toggleTab = (index: any) => {
    setToggleState(index)
  }
  return (
    <div>
      <Wrapper>
        <div className="wrap">
          <div className="pointer">
            <p
              className={
                toggleState === 1
                  ? 'investment active tabs active-tabs'
                  : 'tabs investment active'
              }
              onClick={() => toggleTab(1)}
            >
              My Collabo ({mycollaboLength.length})
            </p>
            <div
              className={
                toggleState === 1 ? 'active-tabss point' : 'tabss point'
              }
            ></div>
          </div>
          <div className="pointer">
            <p
              className={
                toggleState === 2
                  ? 'explore investment active-tabs tabs'
                  : 'explore investment tabs active'
              }
              onClick={() => toggleTab(2)}
            >
              Collabo Invites ({allInvitesLength.length})
            </p>
            <div
              className={
                toggleState === 2
                  ? 'active-tabss explore point'
                  : 'tabss explore point'
              }
            ></div>
          </div>
        </div>
        <div
          className={toggleState === 2 ? 'contents active-content' : 'content'}
        >
          <MyCollabo />
        </div>
        <div
          className={toggleState === 1 ? 'contents active-content' : 'content'}
        >
          <CollaboInvite />
        </div>
      </Wrapper>
    </div>
  )
}

export { CollaboToggle }
